import React from 'react';
import PropTypes from 'prop-types';

function Text({ content, className, style }) {
    return (
    <div className= {className} style={style}>
        <p>{content}</p>
    </div>
    );
}

Text.propTypes = {
    content: PropTypes.string.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
};

export default Text;
